import type { Security } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { getRuleChain } from 'components/SecuritySchema/helpers/getRuleChain';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { selectRuleChainScope } from 'components/SecuritySchema/model/selectors/selectRuleChainScope';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectActiveRuleChain: (
  s: SecuritySchemaMergedState,
) => Security.RuleChain | null = createScopedSelector(() =>
  createSelector(
    prop('deviceSecurity'),
    selectRuleChainScope,
    (deviceSecurity, scope) =>
      deviceSecurity !== null && scope !== null
        ? getRuleChain(scope)(deviceSecurity)
        : null,
  ),
);
